<template>
    <div class="comment">
        <div class="right">
            <img src="@/assets/images/publicAc.png" alt="" class="commentImg" @mouseenter="popups('publicAc')"  @mouseleave="popusLeave('publicAc')">
            <img src="@/assets/images/SmallProgram.png" alt="" class="commentImg" @mouseenter="popups('SmallProgram')" @mouseleave="popusLeave('SmallProgram')">
            <img src="@/assets/images/cooperation.png" alt="" class="commentImg" @mouseenter="popups('cooperation')" @mouseleave="popusLeave('cooperation')">
            <img src="@/assets/images/contact.png" alt="" class="commentImg" @mouseenter="popups('contact')" @mouseleave="popusLeave('contact')">
        </div>
        <div class="zhezhao" v-if="popup || popupS || popupss || popupsss"></div>
        <div class="popup" v-if="popup">
            <img src="@/assets/images/public.png" alt="" class="code">
        </div>
        <div class="popup" v-if="popupS">
            <img src="@/assets/images/wxImg.jpg" alt="" class="code">
        </div>
        <div class="popups" v-if="popupss">
            <img src="@/assets/images/cooperations.png" alt="" class="codeThree" >
        </div>
        <div class="popups" v-if="popupsss">
            <img src="@/assets/images/contacts.png" alt="" class="codeFour">
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    components: {

    },
    props: {},
    data () {
        return {
            popup:false,
            popupS:false,
            popupss:false,
            popupsss:false,
        };
    },
    watch: {},
    computed: {},
    methods: {
        popups(str){
            
            if(str == 'publicAc'){
                this.popup = true
            }else if(str == 'SmallProgram'){
                this.popupS = true
            }else if(str == 'cooperation'){
                this.popupss = true
            }else if(str == 'contact'){
                this.popupsss = true
            }
        },
        popusLeave(str){
            if(str == 'publicAc'){
                this.popup = false
            }else if(str == 'SmallProgram'){
                this.popupS = false
            }else if(str == 'cooperation'){
                this.popupss = false
            }else if(str == 'contact'){
                this.popupsss = false
            }
        }
    },
    mounted () {
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue